import { httpRequest } from '@/apis/request'
import axios from 'axios'

import { SaveCustomTranslationPayload } from './types'

enum Apis {
  saveCustomTranslation = 'language/translation',
}
enum urls {
  en = 'https://eggrj.oss-cn-hangzhou.aliyuncs.com/translate/translationEN.json',
  id = 'https://eggrj.oss-cn-hangzhou.aliyuncs.com/translate/translationID.json',
  ru = 'https://eggrj.oss-cn-hangzhou.aliyuncs.com/translate/translationRU.json',
  th = 'https://eggrj.oss-cn-hangzhou.aliyuncs.com/translate/translationTH.json',
  ug = 'https://eggrj.oss-cn-hangzhou.aliyuncs.com/translate/translationUG.json',
  vie = 'https://eggrj.oss-cn-hangzhou.aliyuncs.com/translate/translationVN.json',
  zh_hant = 'https://eggrj.oss-cn-hangzhou.aliyuncs.com/translate/translationZHTC.json',
  ben = 'https://eggrj.oss-cn-hangzhou.aliyuncs.com/translate/translationBEN.json',
  kz = 'https://eggrj.oss-cn-hangzhou.aliyuncs.com/translate/translationKZ.json',
  ko = 'https://eggrj.oss-cn-hangzhou.aliyuncs.com/translate/translationKO.json',
  bur = 'https://eggrj.oss-cn-hangzhou.aliyuncs.com/translate/translationMY.json',
  tr = 'https://eggrj.oss-cn-hangzhou.aliyuncs.com/translate/translationTR.json',
  km = 'https://eggrj.oss-cn-hangzhou.aliyuncs.com/translate/translationKM.json',
  es = 'https://eggrj.oss-cn-hangzhou.aliyuncs.com/translate/translationES.json',
  ar = 'https://eggrj.oss-cn-hangzhou.aliyuncs.com/translate/translationAR.json',
}
/**
 * @description 保存自定义翻译
 * @link https://api.thinkerx.com/web/#/p/a4d423e481fcc1cec8e54f1ea6c19238
 */
export function saveCustomTranslation(payload: SaveCustomTranslationPayload) {
  return httpRequest.post(Apis.saveCustomTranslation, payload)
}

/**
 * @description 获取
 * @link https://api.thinkerx.com/web/#/p/a4d423e481fcc1cec8e54f1ea6c19238
 */
export function getCustomTranslation(payload: string) {
  return httpRequest.get(Apis.saveCustomTranslation, {
    language: payload,
  })
}

// 标签独立的翻译表
export function getLabelTranslation(params: { language: keyof typeof urls }) {
  return axios.get(urls[params.language])
}
